/**
 * Returns an array of unique objects from a given array based on a specified key.
 *
 * @param array - The input array containing objects to be filtered.
 * @param key - The key in each object that should be used to determine uniqueness.
 *
 * @returns An array containing only the unique objects based on the specified key.
 */
export const getUniqueObjects = (array: any[], key: string): any[] => {
  const keyValues = array.map((item) => {
    return item ? [item[key], item] : [null, null];
  });
  // @ts-ignore
  return [...new Map(keyValues).values()];
};
